export default __webpack_public_path__ + "static/media/time.34762496.svg";